module.exports = __webpack_public_path__ + "static/media/a34.5b828ab2.jpg";